export default __webpack_public_path__ + "static/GPTW24-e5ad0ea624201f80c6b325d204deb07c.png";